import React, { FC } from 'react';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import { Modal } from '../../../components/modal/index';
import { useLocale } from '../../../hooks/index';

export type InviteSubEmailsProps = {
  isOpen: boolean;
  onDismiss: () => void;
  onHardClose: () => void;
  onSuccess: () => void;
};

export const InviteSubEmailsModal: FC<InviteSubEmailsProps> = ({
  isOpen,
  onDismiss,
  onSuccess,
  onHardClose,
}) => {
  const { messagesLocale } = useLocale();
  return (
    <Modal
      crossButton
      description={<AppFormattedMessage id="INVITE_ALL_SUB_EMAILS_DESCRIPTION" />}
      dismissButtonContent={<AppFormattedMessage id="NO_ONLY_MAIN_STAKEHOLDER" />}
      isOpen={isOpen}
      onDismiss={onDismiss}
      onHardClose={onHardClose}
      onSuccess={onSuccess}
      successButtonClassName="bg-brand-700"
      successButtonContent={messagesLocale['YES_INVITE_ALL']}
      title={<AppFormattedMessage id="INVITE_ALL_SUB_EMAILS" />}
    />
  );
};
